import React from "react"
import PropTypes from "prop-types"
import Img from "gatsby-image/withIEPolyfill"

export default class LoungeInfo extends React.Component {
  constructor() {
    super()
    this.state = { isOpen: false }
    this.zoomBtn = React.createRef()
    this.closeBtn = React.createRef()
  }

  openModal = (event) => {
    this.setState(state => ({ isOpen: !state.isOpen }))
    setTimeout(
      function() {
        this.closeBtn.current.focus()
      }.bind(this),
      0
    );
  }

  closeModal = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
    this.zoomBtn.current.focus()
  }

  closeWithEscape = (ev) => {
    if (ev.keyCode === 27) {
      this.closeModal()
    }
  }

  render() {
    const { info, inLounge } = this.props
    return (
      <div className="lounge-location container container--med island">
        <h2 className="h2">{info.title}</h2>
        <div className="grid-wrapper">
          <div className="grid two-fifths lap-one-fifth desk-one-sixth">
            <div className="terminal landmarklet text-center">
              <div className="terminal-head">{info.loungeTerminal}</div>
              <div className={info.alternateTextSize ? 'terminal-letter terminal-letter--small': 'terminal-letter'}>{info.loungeTerminalLetter}</div>
              {info.loungeLocation &&
                <div className="terminal-foot">{info.loungeLocation}</div>
              }
            </div>
          </div>
          {info.smallMapImage &&
            <div className="grid three-fifths lap-one-quarter">
              <div className="map landmarklet">
                <Img fluid={info.smallMapImage.localFile.childImageSharp.fluid} />
                {info.largeMapImage &&
                  <button ref={this.zoomBtn} className="btn-zoom" onClick={this.openModal}>
                    <i className="icon-zoom-in"></i>
                    <span className="visuallyhidden">View Map Larger</span>
                  </button>
                }
              </div>
            </div>
          }
          <div className="grid lap-six-twelfths desk-seven-twelfths">
            {inLounge && info.surveyText && info.surveyUrl &&
              <p><a className="btn dim" href={info.surveyUrl} target="_blank" rel="noopener noreferrer">{info.surveyText}</a></p>
            }
            <div dangerouslySetInnerHTML={{__html: info.description}} />
            {inLounge && info.inLoungeDescription &&
              <div dangerouslySetInnerHTML={{__html: info.inLoungeDescription}} />
            }
          </div>
        </div>

        {info.largeMapImage &&
          <div role="dialog" className={this.state.isOpen ? 'modal open': 'modal'}>
            <div className="modal-content">
              <button ref={this.closeBtn} className="close" onClick={this.closeModal} onKeyDown={this.closeWithEscape}><i className="icon-close"></i><span className="visuallyhidden">Close</span></button>
              <Img fluid={info.largeMapImage.localFile.childImageSharp.fluid} alt="Lounge Map" />
            </div>
            <div className="modal-overlay" onClick={this.closeModal} aria-hidden="true"></div>
          </div>
        }
      </div>
    )
  }
}

LoungeInfo.propTypes = {
  info: PropTypes.object.isRequired,
  inLounge: PropTypes.bool,
}
